import { NavigationBar } from "../../../../../components/navigation/NavigationBar";
import { ToastProvider } from "../../../../../components/toast/useToast";
import { useSellarCurrentBusiness } from "../../../../../hooks/useSellarCurrentBusiness.shared";
import { StorefrontShareContent } from "./StorefrontShareContent";

export const StorefrontShare = () => {
  const { business } = useSellarCurrentBusiness();
  if (!business?.Supplier) throw new Error("Only suppliers can view");
  return (
    <>
      <NavigationBar title={"Share"} />
      <ToastProvider>
        <StorefrontShareContent />
      </ToastProvider>
    </>
  );
};
